package xim.poc.game

import xim.poc.browser.GameKey
import xim.poc.browser.LocalStorage
import xim.util.FrameTimer
import kotlin.time.Duration

object InputThrottler {

    private val keyThrottle = HashMap<GameKey, FrameTimer>()
    private var pressedThisFrame = HashSet<GameKey>()

    private val settings = LocalStorage.getConfiguration()

    fun update(elapsedFrames: Float) {
        pressedThisFrame.clear()
        keyThrottle.values.forEach { it.update(elapsedFrames) }
    }

    fun admit(gameKey: GameKey, duration: Duration): Boolean {
        if (pressedThisFrame.contains(gameKey)) { return true }

        val throttle = keyThrottle.getOrPut(gameKey) { FrameTimer(duration, initial = Duration.ZERO) }
        if (throttle.isNotReady()) { return false }

        throttle.reset(duration * getMultiplier())
        pressedThisFrame += gameKey
        return true
    }

    private fun getMultiplier(): Double {
        val setting = settings.cursorSpeed
        return 1.0 + (100.0 - setting)/100
    }

}